export const RoleMessages = {
  NO_DESCRIPTION: 'role.no-description',
  COMPETENCIES_REQUIRED: 'role.competencies-required',
  SKILLS_REQUIRED: 'role.skills-required',
  PEOPLE_IN_ROLE: 'role.people-in-role',
  ASSOCIATED_DEPARTMENT: 'role.associated-department' // department
};
